import { useCallback, useState } from 'react';
import { NestedSelectableOptions } from '../searchable-dropdown.type';

interface UseGroupExpansionProps {
    groups: NestedSelectableOptions[];
    visible: boolean;
    expandGroupsByDefault: boolean;
}

export const useGroupExpansion = ({ groups, visible, expandGroupsByDefault }: UseGroupExpansionProps) => {
    const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());
    const [lastExpansionKey, setLastExpansionKey] = useState<string>('');

    const groupIds = groups.map(({ id }) => id);
    const expansionKey = JSON.stringify([visible, expandGroupsByDefault, expandGroupsByDefault ? groupIds : []]);

    if (expansionKey !== lastExpansionKey) {
        setLastExpansionKey(expansionKey);
        setExpandedItems(new Set(expandGroupsByDefault ? groupIds : []));
    }

    const toggleExpanded = useCallback((itemId: string, isExpanded: boolean) => {
        setExpandedItems((previous) => {
            const next = new Set(previous);

            if (isExpanded) {
                next.add(itemId);
            } else {
                next.delete(itemId);
            }

            return next;
        });
    }, []);

    return { expandedItems, toggleExpanded };
};
